export const calculateRatio = (antecedent?: number, consequent?: number) => {
  if (
    antecedent !== undefined &&
    antecedent >= 0 &&
    consequent !== undefined &&
    consequent > 0
  ) {
    return antecedent / consequent;
  }
  return 0;
};
